import React, { useState, useRef, useContext } from 'react'
import { Field, Formik, Form, ErrorMessage } from 'formik';

import TextAreaField from '../Form/TextAreaField';
import * as yup from 'yup';
import { ValidationError } from '../Errors/ValidationError';
import { LeadsContext } from '../Context/LeadsContext';

const QuickUpModal = ({ close }) => {

    const {addLead, validateVIN} = useContext(LeadsContext);

    const validationSchemaStep1 = yup.object({
        vin: yup.string().required("Please enter your VIN").test(
            "valid-vin",
            "Please enter a valid VIN.",
            (value) => validateVIN(value)
          ),
        mileage: yup.number().required("Please enter a mileage").min(1,'Mileage must be greater than 0'),
        email: yup.string().nullable().email(),
    });
    
    const validationSchemaStep2 = yup.object({
        first_name: yup.string().required("Please enter first name"),
        last_name: yup.string().required("Please enter last name"),
        email: yup.string().required("Please enter email").nullable().email("Please enter email"),
        phone: yup.string().required("Please enter phone number"),
    });

    const [formikData, setFormikData] = useState({
        vin: "",
        mileage: 0
    });
    const [formikData1, setFormikData1] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        note: ""
    });

    const formikRef = useRef(null);

    const [activeAccordian, setActiveAccordian] = useState(0);

    const handleSubmit = async (values) => {
        console.log(values);

        const data = await addLead(values);

        if(data.success) {
            close();
            alert("Lead added");
        } else {
            alert("Error adding lead");
        }
    }

    return (
        <>

            <div className="modal-header">
                <h1 className="modal-title text-uppercase" id="staticBackdropLabel">
                    Quick Up
                </h1>
                <button className="sm-box-close" type="button" onClick={close}>
                    <i className="fa-solid fa-xmark"></i>
                </button>
            </div>
            <div className="modal-body px-0 py-3">
                <div className="accordion quick-accordion" id="accordionExample">
                    <div className="accordion-item mb-2">
                        <h2 className="accordion-header" id="headingOne">
                            <button className="accordion-button d-flex align-itmes-center justify-content-between w-100" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                <div>STEP 1</div>
                                <div>Vehicle Info</div>
                            </button>
                        </h2>
                        <div id="collapseOne" className={`accordion-collapse collapse ${activeAccordian == 0 ? 'show' : ''}`} aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div className="accordion-body py-5">
                                <div className='p-3'>
                                    <Formik
                                        initialValues={formikData}
                                        validationSchema={validationSchemaStep1}
                                        onSubmit={(values, { resetForm }) => {
                                            console.log(values);
                                            setActiveAccordian(1);
                                        }}
                                        enableReinitialize={true}
                                        innerRef={formikRef}
                                    >
                                        {({ values }) => (
                                            <Form className='custom-form form-style2 align-items-end row'>
                                                <div className='form-group col-md-5'>
                                                    <label>ENTER VIN NUMBER</label>
                                                    {/* <input type='text' className='form-control' placeholder='Enter vin here ...' /> */}
                                                    <Field name="vin" type="text" className='form-control' placeholder='Enter vin here ...'/>
                                                    
                                                </div>
                                                <div className='form-group col-md-2'>
                                                    <label>mileage</label>
                                                    <Field name="mileage" type="text" className='form-control' placeholder='0'/>
                                                </div>
                                                <div className='form-group col-md-5'>
                                                    <button className='blue-btn w-100 text-uppercase enter-btn' type='submit'>Enter</button>
                                                </div>
                                                <ValidationError name="vin"/>
                                                <ValidationError name="mileage"/>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item mb-2">
                        <h2 className="accordion-header" id="headingTwo">
                            <button className="accordion-button collapsed d-flex align-itmes-center justify-content-between w-100" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                <div>STEP 2</div>
                                <div>Customer Info</div>
                            </button>
                        </h2>
                        <div id="collapseTwo" className={`accordion-collapse collapse ${activeAccordian == 1 ? 'show' : ''}`} aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                            <div className="accordion-body py-4">
                                <div className='p-0'>
                                    <Formik
                                        initialValues={formikData1}
                                        validationSchema={validationSchemaStep2}
                                        onSubmit={(values, { resetForm }) => {
                                            console.log(formikRef.current.values,values);
                                            handleSubmit({...formikRef.current.values,...values});
                                        }}
                                        enableReinitialize={true}
                                    >
                                        {({ values }) => (
                                            <Form className='custom-form form-style2 row'>
                                                <div className='form-group col-md-6 mb-3'>
                                                    <label>FIRST NAME</label>
                                                    <Field name="first_name" type="text" className='form-control'/>
                                                    <ValidationError name="first_name"/>
                                                </div>
                                                <div className='form-group col-md-6 mb-3'>
                                                    <label>LAST NAME</label>
                                                    <Field name="last_name"  type="text" className='form-control'/>
                                                    <ValidationError name="last_name"/>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group mb-3'>
                                                        <label>EMAIL</label>
                                                        <Field name="email" type="text" className='form-control'/>
                                                        <ValidationError name="email"/>
                                                    </div>
                                                    <div className='form-group mb-3'>
                                                        <label>PHONE</label>
                                                        <Field name="phone" type="text" className='form-control'/>
                                                        <ValidationError name="phone"/>
                                                    </div>
                                                </div>
                                                <div className='form-group col-md-6 mb-3'>
                                                    <label>NOTES</label>
                                                    <TextAreaField name="note" className='form-control h-122'></TextAreaField>
                                                </div>
                                                <div className='form-group col-12 text-center'>
                                                    <button className='blue-btn mxw-240 w-100 text-uppercase enter-btn' type='submit'>Update</button>
                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default QuickUpModal